import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './i18n'; // <-- Initialisation i18n

import { metricsService } from './services/metricsService'
import { a11yManager } from './utils/accessibility'
import { QueryProvider } from './providers/QueryProvider'
import { initSentry } from './services/sentry'
import { globalActions } from './store'

// Suppress specific React warnings that are not critical (like jsx attribute warnings)
const originalWarn = console.warn;
console.warn = (...args) => {
  // Filter out the jsx attribute warning from libraries like Framer Motion
  if (args[0] && typeof args[0] === 'string') {
    const message = args[0];
    if (message.includes('Received `true` for a non-boolean attribute `jsx`') ||
        message.includes('jsx') && message.includes('non-boolean attribute')) {
      // Log for debugging but suppress the warning
      console.debug('JSX warning suppressed:', message);
      return; // Suppress this warning
    }
  }
  originalWarn.apply(console, args);
};

// Initialiser Sentry en premier
initSentry();

// Dev: s'assurer qu'aucun service worker ne bloque HMR
if (import.meta.env.DEV && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((r) => r.unregister()));
  if ('caches' in window) {
    caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
  }
}

// Initialiser les services de monitoring
metricsService.startWebVitalsMonitoring();

// Initialiser l'accessibilité
a11yManager.announcePageChange('Application Ekose-Rx');

// ✅ CORRECTION: Initialiser le store global Zustand UNIQUEMENT si un token existe
// Sans token, le presenceStore lancerait des requêtes API qui échoueraient en 401
// et déclencheraient une cascade de refresh tokens inutiles.
// L'AuthContext se chargera d'appeler initialize() après vérification du token.
const existingToken = localStorage.getItem('authToken') || localStorage.getItem('token');
if (existingToken) {
  globalActions.initialize();
} else {
  console.debug('[main] Pas de token — initialisation globale différée');
}

// Initialiser la synchronisation du store avec les services
import UserSyncService from './services/userSyncService';
UserSyncService.getInstance().setupStoreSync();

// ✅ CORRECTION: Wrapper simple et unifié sans conditionnelle
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

// Créer le root React
const root = ReactDOM.createRoot(rootElement);

// Rendu en mode strict (recommandé même en production)
root.render(
  <React.StrictMode>
    <QueryProvider>
      <App />
    </QueryProvider>
  </React.StrictMode>
);